var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_2338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66675C10.8465 2.66675 6.6665 6.84675 6.6665 12.0001C6.6665 19.0001 15.9998 29.3334 15.9998 29.3334C15.9998 29.3334 25.3332 19.0001 25.3332 12.0001C25.3332 6.84675 21.1532 2.66675 15.9998 2.66675ZM15.9998 15.3334C14.1598 15.3334 12.6665 13.8401 12.6665 12.0001C12.6665 10.1601 14.1598 8.66675 15.9998 8.66675C17.8398 8.66675 19.3332 10.1601 19.3332 12.0001C19.3332 13.8401 17.8398 15.3334 15.9998 15.3334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.3cf75dbc21771c8b8822c0f195ba04b6.svg";
export { ForwardRef as ReactComponent };